import { useContext } from 'react'
import { GameContext } from '../context/GameContext'

export default function ShowAll () {
  const { displayAnswers, error, percentCompleted } = useContext(GameContext)
  return (
    <>
      {percentCompleted >= 50 && (
        <button
          onClick={displayAnswers}
          className={`animate__bounceIn w-full p-2 mt-3 hover:bg-[#62cf3a] all duration-[200ms] ease-in-out bg-white rounded ${
            error ? 'btnDisabled' : ''
          }`}
        >
          Show All words
        </button>
      )}
    </>
  )
}
